import { Component, OnInit } from '@angular/core';

import { DarkModeService } from './../../services/darkmode.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-how-ayr-works',
  imports: [TranslateModule],
  templateUrl: './how-ayr-works-citizens.component.html',
  styleUrl: './how-ayr-works-citizens.component.scss',
})
export class HowAyrWorksCitizensComponent implements OnInit {
  public darkMode = false;

  constructor(private darkModeService: DarkModeService) {}

  ngOnInit(): void {
    this.darkModeService.isDarkMode.subscribe((dark) => (this.darkMode = dark));
  }
}
